export default __webpack_public_path__ + "static/media/silentAuction.c0184d27.jpg";